import {ChatbotMessage, MessageFrom} from '../../../../shared/models/api';
import {IMessageModified} from './model';

export const buildMessage = (message: ChatbotMessage): IMessageModified => {
  return {
    _id: message.sentAt,
    createdAt: new Date(message.sentAt),
    user: {
      _id: message.role ?? MessageFrom.USER,
    },
    text: message.text?.trim(),
    general: message.isGeneralQuestion && message.actions != null,
    useful: message.isUsefulAnswer && message.actions != null,
    quickReplies: message.actions?.length
      ? {
          type: 'radio' as const,
          keepIt: true,
          values: message.actions.map(({id, label, action}, index) => ({
            messageId: id ?? index,
            title: label,
            value: action,
          })),
        }
      : undefined,
  };
};
